<template>
	<div class="basic_wrap" v-if="data">
		<div class="red_top_bg">
			<div class="back_left" @click="$router.back()"></div>
			<div class="big_tit">{{$t('shopd.odetail')}}</div>
			<!-- <div class="top_right" @click="$router.push('/moneybag')">
				<van-icon name="bars" size="25"/>
			</div> -->
		</div>
		<!-- <div class="status">{{$t('shopd.oprogress')}}</div> -->
		<div v-if="time>0 && data.stat==50" class="pending-tips van-row bgdeep">
			<div  class="van-col van-count-down"> 
				{{$t('c3.timecount')}}
				 <van-count-down style="display: initial; font-size: 2vh; " :auto-start='true' :time="time" format="HH:mm:ss" />
				 .
			</div>
		</div>
		<div class="box goods bglight shadow" v-if="data">
		    <div class="header1 bglight">
		        <svg class="icon" viewBox="0 0 1024 1024" width="18" height="18">
		            <path d="M952.832 352.768c-0.064-0.48-0.16-0.928-0.256-1.312-0.384-1.856-0.896-3.648-1.632-5.376L875.936 159.36c-12.96-38.592-48.832-62.56-93.952-62.56L255.488 96.8c-44.224 0-78.592 23.52-91.04 60.704l-80.64 190.528c-0.384 1.12-0.8 2.784-1.152 4.48-5.856 17.984-8.8 36.448-8.8 54.976 0.064 65.184 35.84 124.704 93.28 155.264 23.648 12.672 51.52 19.072 82.816 19.072 0.032 0 0.064 0 0.096 0 52.512-0.128 101.152-23.2 134.304-62.688 32.992 39.136 81.248 62.08 133.664 62.4 52-0.384 100.096-23.424 132.96-62.56 33.152 39.488 81.856 62.496 134.624 62.496 31.936-0.192 60.288-6.88 84.16-20 56.576-30.88 91.68-90.176 91.648-154.656C961.44 388.256 958.4 369.696 952.832 352.768zM766.432 383.968 254.4 383.968c-17.664 0-32-14.336-32-32s14.336-32 32-32l512.032 0c17.696 0 32 14.336 32 32S784.128 383.968 766.432 383.968z"
		                  p-id="2387" fill="#323233"></path>
		            <path d="M895.072 640c0-17.696-14.304-32-32-32-3.296 0-6.272 0.928-9.248 1.888l0 0c-23.712 9.376-54.048 14.432-76.928 13.184-50.432-2.688-88.864-12.736-125.888-44.256-36.512 31.136-83.104 48.864-132.704 49.312-50.304-0.32-97.152-12.928-133.856-44.128-36.928 31.488-84.064 46.816-134.272 46.816L249.984 630.816c-30.656 0-47.936-5.824-75.84-16.128-0.768-0.384-1.568-0.576-2.368-0.864-1.344-0.512-2.368-0.864-3.744-1.376 0 0-4.608-0.8-7.136-0.8 0 0-0.032 0-0.064 0-17.664 0-31.968 14.368-31.936 32.064l0.224 171.488c0 45.12 36.768 81.824 81.984 81.824l602.176-0.384c45.152-0.128 81.888-36.928 81.888-82.048L895.072 640z"
		                  fill="#323233"></path>
		        </svg>
		        <span style="overflow: hidden;height: 5vh;display: block;">
					KOTEMU Store
				</span>
				<!-- <div class="time">{{data.oing}}/{{data.tnum}}</div> -->
			</div>
		    <div class="content bglight">
		        <div class="left"><img :src="data.pic"></div>
		        <div class="right">
		            <div class="title">{{data.title}}</div>
		            <div class="price-number">
		                <div class="price">{{utils_moneyMark()}} {{data.price}}</div>
		                <div class="number">x1</div>
		            </div>
					 <!-- <div class="earnings">{{$t('shopd.commission')}}: <em>{{utils_moneyMark()}} {{data.fee}}</em></div> -->
		            <!-- <div>Commission: $ {{data.fee}}</div> -->
		        </div>
		    </div>
			<div class="infos">
			    <div class="inf">
			        <div class="tit">{{$t('c3.totalamaout')}}</div>
			        <div class="val">{{utils_moneyMark()}} {{data.price}}</div>
			    </div>
			    <div class="inf">
			        <div class="tit">{{$t('c3.commission')}}</div>
			        <div class="val">{{Number((100*data.rate).toFixed(3))}} %</div>
			    </div>
			    <div class="inf">
			        <div class="tit">{{$t('c3.earnings')}}</div>
			        <div class="val">{{utils_moneyMark()}} {{data.fee}} </div>
			    </div>
			    <div class="inf">
			        <div class="tit">{{$t('c3.paystat')}}</div>
			        <div class="val" v-if="data.pay=='0'" >
						{{$t('c3.unpay')}}
					</div>
					<div class="val " v-if="data.pay=='1'" style="color: #3f9a43;">
						{{$t('c3.paid')}}
					</div>
			    </div>
			</div>
			<div class="notice" v-if="data.stat==98 || (data.stat==99 && data.pay=='0')">
				<div>
					<van-icon name="warning-o" size="50" color="#d2d214"/>
				</div>
				<div>
				{{$t('c3.ofrezee')}}
				</div>
			</div>
			<div class="notice" v-if="data.stat==99 && data.pay=='1'">
				<div>
					<van-icon name="passed" size="50" color="grey"/>
				</div>
				<div>
					{{$t('c3.odetailpaid')}}
				</div>
			</div>
			<div class="notice" v-if="data.stat==100 || data.stat==101">
				<div>
					<van-icon name="passed" size="50" color="#3f9a43"/>
				</div>
				<div>
					{{$t('c3.odetailfinsh')}}
				</div>
			</div>
		</div>
		 <!-- @click="doorder()" -->
		<div v-if="data.stat==50" id="submit_button" @click="write_psd = true;submitType = 1;"  class="button submit btn">
			{{$t('c3.pay')}}
		</div>
		<div>
			
		</div>
	<!-- 	<div class="user_top1 bgdeep">
		   <div class="award_tip">
				<p>
				{{$t('c3.odetailt1')}} {{data.tnum}} {{$t('c3.odetailt2')}} {{data.oing}}{{$t('c3.odetailt3')}}
				</p>
		   </div>
		</div> -->
		
		
		<van-popup v-model="write_psd" closeable close-icon="close" round position="bottom">
		    <div class="psw_box">
		        <van-password-input :value="psd_val" :mask="true" :focused="showKeyboard" @focus="showKeyboard = true" />
		        <div class="keybord_box">
		            <div class="keybord">
		                <div class="key_item" v-for="i in 9" @click="onInput(i)">
		                    <div class="key_inner">{{i}}</div>
		                </div>
		                <div class="key_item no_bg">
		                    <div class="key_inner"></div>
		                </div>
		                <div class="key_item" @click="onInput(0)">
		                    <div class="key_inner">0</div>
		                </div>
		                <div class="key_item no_bg x" @click="onDelete">
		                    <div class="key_inner">x</div>
		                </div>
		            </div>
		        </div>
		    </div>
		</van-popup>
		<div v-show="setPwd" class="real_name_mask">
				<div class="real_box">
					<div class="tit" />
					<p class="tips">
						{{$t('cash.setPwdFirst')}}
					</p>
					<div class="basic_btn" @click="setIniPwd">
						{{$t('cash.setNow')}}
					</div>
				</div>
			</div>
		</div>
	</div>

	
</template>

<script>
	import Vue from "vue";
	import {
		Empty,CountDown
	} from "vant";
    var _that;
	import {
		Dialog,
		DropdownMenu,
		DropdownItem,
		Popup,
		PasswordInput,
		NumberKeyboard,
		Icon,
		ActionSheet
	} from 'vant';
	import Fetch from "../../utils/fetch";
	Vue.use(Empty).use(CountDown).use(Dialog).use(PasswordInput).use(NumberKeyboard).use(Popup).use(DropdownMenu).use(DropdownItem).use(Icon).use(ActionSheet);
	export default {
		name: "odetail",
		data() {
			return {
				lang: this.$i18n.locale || "zh_cn",
				time:0,
				need:0,
				showKeyboard: true,
				write_psd: false,
				psd_val: '',
				password:'',
				show:false,
				data: null
			};
		},
		created() {
			this.$parent.footer("ordering");
		},
		mounted() {
			this.start();
			_that = this;
		},
		methods: {
			onInput(key) {
			    this.psd_val = (this.psd_val + key).slice(0, 6);
			    if (this.psd_val.length == 6) {
					this.write_psd = false;
					this.password = this.psd_val;
					if(this.submitType==1){
						this.doorder();
					}else{
						this.setIniPwdSubmit();
					}
					
			    }
			},
			onDelete() {
			    this.psd_val = this.psd_val.slice(0, this.psd_val.length - 1);
			},
			start() {
				Fetch("/user/orderdetail", {
					id: this.$router.history.current.params.code
				}).then((r) => {
					this.data = r.data;
					this.setPwd = r.data.intPwd;
					var item = r.data;
					if(item.rt){
						var currentTimestamp = Date.now()/1000;
						var time = (item.rt-currentTimestamp)*1000;
						if(time<0){
							time=0;
						}
						this.time=time;
					}
				});
			},
			setIniPwdSubmit(){
				this.psd_val="";
				Fetch('/user/setIniPwd', {
				    password: this.password
				}).then(() => {
					this.setPwd = false;
				});
			},
			setIniPwd(){
				this.submitType = 2;
				this.write_psd = true;
			},
			doorder(){
				this.psd_val="";
				
				Fetch("/user/doorder", {
					id: this.data.id,
					passwd: this.password
				}).then(r => {
					// showDialog({
					//   message: this.$t('shopd.corder'),
					//   theme: 'round-button',
					// }).then(() => {
					//   this.$router.push('/grap');
					// });
					if(r&& r.data && r.data==1){
						this.$toast({
							duration:'5000',
							background: '#07c160',
							message: this.$t('shopd.corder')
						});
						this.$router.push('/ordering');
					}else{
						this.$toast({
							duration:'5000',
							background: '#07c160',
							message: this.$t('shopd.corder')
						});
						this.$router.push('/ordered');
					}
					
				}).catch(err=>{
					if(err && err.code==0 && err.data && err.data.need){
						Dialog.confirm({
							title: 'Tips',
							confirmButtonText:this.$t('moneybag.recharge'),
							cancelButtonText:this.$t('shopd.cancelbtn'),
							message: this.$t('c3.need') + " " +this.utils_moneyMark()+ err.data.need.toFixed(0)
						})
						.then(() => {
						  this.$router.push('/invest');
						})
						.catch(() => {
						});
						
					}
				})
			}
		},
	};
</script>

<style lang="less" scoped>
	.red_top_bg {
		
	}

	.money_box {
		display: flex;
		justify-content: space-around;
		border-radius: 10px;
		padding: 10px;
		margin: 10px;
		color:#36333d;
		background: #FFF;

		.item {
			width: 33.33%;
			text-align: center;
			font-weight: bold;

			.money_num {
				font-size: 18px;
				line-height: 25px;
				white-space: normal;
				word-break: normal;
				text-align: center;
			}

			.info {
				font-size: 12px;
				line-height: 20px;
				font-weight: normal;
				margin-top: 5px;
			}
		}
	}

	/deep/ .van-password-input {
        margin: 50px 28px 0 28px;
    }

    /deep/ .van-hairline--left::after {
        border: 1px solid #ECECEC;
    }

    .van-password-input .van-password-input__security::after {
        border-radius: 0;
    }
    .keybord_box {
        height: 250px;
        background-color: #F0F0F0;
        margin-top: 35px;
        padding: 24px 12px 0 12px;

        .keybord {
            width: 361px;
            margin: 24px auto 0 atuo;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            text-align: center;

            .key_item {
                width: 115px;
                height: 44px;
                line-height: 44px;
                font-size: 18px;
                font-weight: bold;
                margin-bottom: 6px;
                background: rgba(255, 255, 255, 1);
                border-radius: 3px;

                &.no_bg {
                    background: none;
                }

                &.x {
                    color: #757880;
                    font-weight: bold;
                }
            }
        }
    }
	.notes_tit {
		line-height: 44px;
		height: 44px;
		font-size: 14px;
		color: #000000;
		padding: 0 14px;
		background: #FAFAFA;
		z-index: 2;
		margin: 10px;
		border-radius: 5px;
	}

	.notes_box {
		width: 100%;
		padding-bottom: 2px;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 2px 9px 2px rgba(160, 160, 160, 0.15);
		border-radius: 6px;
		margin-bottom: 10px;

		.timer {
			padding: 3px 3px;
			font-size: 12px;
			color: rgba(0, 0, 0, .6);
			border-bottom: 1px solid #ececec;
			display: flex;
			justify-content: space-between;
			align-items: center;

			span {
				font-style: normal;
				padding: 5px;
				border-radius: 5px;
				color: #FFFFFF;
			}

			.ing {
				background: #3775f4;
			}

			.finish {
				font-style: normal;
				background: #07c160;
			}
		}

		.item_div1 {
			display: flex;
			justify-content: space-between;
			padding: 15px 10px;

			p:nth-child(1) {
				width: 100%;
				font-weight: bold;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;

			}
		}

		.item_div2 {
			display: flex;
			justify-content: space-between;
			text-align: center;
			margin-bottom: 5px;
			margin-top: 5px;
			div {
				width: 33.33%;

				p {
					padding: 5px 0;
				}
			}

			.item_rate {
				p:nth-child(1) {
					font-weight: bold;
					font-size: 14px;
					color: #FF0000;

				}

				p:nth-child(2) {
					color: #999;
				}
			}

			.item_day {
				p:nth-child(1) {
					font-weight: bold;
					font-size: 14px;

				}

				p:nth-child(2) {
					color: #999;
				}
			}

			.item_min {
				p:nth-child(1) {
					font-weight: bold;
					font-size: 14px;

				}

				p:nth-child(2) {
					color: #999;
				}
			}
		}
	}

	.scrollBox {
		width: 96%;
		margin-left: 2%;
	}
	
	
	.box {
		margin: 3vw;
		border-radius: 2vw;
		overflow: hidden;
	    background-color: rgb(12, 109, 86);
		padding: 0;
		color: #FFF;
		.header1 {
			position: relative;
			padding: 0 10px 0 34px;
			height: 40px;
			line-height: 40px;
			font-size: 14px;
			font-weight: bold;
			background: linear-gradient(180deg, #36333d, #746b0a);
			background: #3b2f5e;
			display: flex;
			 .icon {
			    position: absolute;
			    left: 10px;
			    top: 11px;
			}
			.id {
			    font-weight: bold;
				color: #FFF;
			}
			.time {
			    flex: 1;
			    text-align: right;
			    font-size: 10px;
			}
		}
		.button {
		    display: block;
		    padding: 0 10px;
		    border-radius: 5px;
		    height: 40px;
		    line-height: 40px;
		    font-size: 18px;
		    color: #202226;
		    text-align: center;
		    background: linear-gradient(180deg, #ff976a, #f1bb0e);
		    overflow: hidden;
		    cursor: pointer;
		}
		.content {
		    display: flex;
		    padding: 10px;
			.left {
				border-radius: 5px;
				width: 90px;
				height: 90px;
				padding: 2px;
				text-align: center;
				background-color: #75777a;
				overflow: hidden;
				img {
				    border-radius: 3vw;
				    width: 90px;
				    height: 90px;
				}
			}
			.right {
			    flex: 1;
				padding-left: 10px;
				line-height: 20px;
				.title {
					margin-bottom: 10px;
					font-weight: 500;
				}
				 .price,.earnings {
				    color: #282828;
					line-height: 3vh;
					 em {
						font-style: normal;
						font-size: 16px;
						font-weight: bold;
						color: #e5ae2f;
					}
				}
				.price-number {
				    display: flex;
				    margin-top: 10px;
					.price {
					    color: #e5ae2f;
					    font-size: 16px;
					    font-weight: bold;
					}
					.number {
					    flex: 1;
					    color: #ffffff;
					    text-align: right;
					}
				}
			}
			.button {
			    display: block;
			    padding: 0 10px;
			    border-radius: 5px;
			    height: 40px;
			    line-height: 40px;
			    font-size: 18px;
			    color: #202226;
			    text-align: center;
			    background: linear-gradient(180deg, #ff976a, #f1bb0e);
			    overflow: hidden;
			    cursor: pointer;
			}
		}
	}
	.status {
	    margin-top: 10px;
	    border-bottom: 1px solid #707070;
	    height: 50px;
	    line-height: 50px;
	    color: #ffffff;
	    font-size: 16px;
	    text-align: center;
	}
	.button {
	    display: block;
	    padding: 0 10px;
	    border-radius: 5px;
	    height: 40px;
	    line-height: 40px;
	    font-size: 16px;
	    color: #FFF;
	    text-align: center;
		background: linear-gradient(180deg, #ff976a, #f1bb0e);
	    overflow: hidden;
	    cursor: pointer;
	}
	.submit {
	    margin: 30px 10vw;
	}
	.goods {
	    padding: 0;
	    background-color: #fff;
	    color: #000;
		.notice{
			display: block;
			height: 10vh;
			text-align: center;
			font-size: 1.5vh;
			margin: 3vh;
			div{
				margin: 1vh;
			}
		}
	}
	.pending-tips{
	    margin: 3vw;
	    border-radius: 2vw;
	    padding: 10px;
	}
	.van-count-down {
	    font-size: 14px;
	    line-height: 20px;
	}
	
	.infos {
	    padding: 14px 1vw;
		.inf {
		    display: flex;
		    justify-content: space-between;
		    padding: 16px 0;
		    font-size: 13px;
		    border-bottom: 1px solid #727d91;
			.tit {
				padding: 0 5px;
			}
			.val {
				padding: 0 5px;
			    font-weight: 500;
			    font-size: 14px;
				color: #e5ae2f;
				font-weight: bold;
			}
		}
	}
	.user_top1{
		width: 96%;
		position: relative;
		// background: #3b2f5e;
		left: 2%;
		border-radius: 5px;
		padding: 15px 0;
		margin-top: 10px;
		 background-color: rgba(0, 0, 0, 0.3);
		
		.award_tip {
		    font-size: 14px;
		    line-height: 20px;
		    text-align: left;
		    margin: 3px 3vw;
			
		}
	}
	.bglight {
	    background: #fff !important;
	    color: #323233 !important;
	}
</style>
